// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"thumb-up-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M19.4609 19.3041L20.6455 11.6041C20.8319 10.3926 19.8945 9.3 18.6688 9.3H13.8V5.84605C13.8 4.68389 13.0563 3.65211 11.9538 3.28461L11.1 3L7.5 11.1H4V21H17.4842C18.4713 21 19.3108 20.2798 19.4609 19.3041Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19.4609 19.3041L20.6455 11.6041C20.8319 10.3926 19.8945 9.3 18.6688 9.3H13.8V5.84605C13.8 4.68389 13.0563 3.65211 11.9538 3.28461L11.1 3L7.5 11.1H4V21H17.4842C18.4713 21 19.3108 20.2798 19.4609 19.3041Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ThumbUp1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'thumb-up-1',
    ref,
    icon: element,
  },
));

ThumbUp1Icon.displayName = 'ThumbUp1Icon';

export default ThumbUp1Icon;
